
export class CompetitionDisciplines {
    public id: number;
    public discipline: string;
    public viewOrder: string;



    constructor(rawItem: any) {
        this.id = rawItem.Id;
        this.discipline = rawItem.Discipline;
        this.viewOrder = rawItem.ViewOrder;
    }


}